import cn from "classnames";
import cs from "@/styles/modules/card.module.scss";
import s from "./NumberedCard.module.scss";
import { WrappedIcon } from "@/components/UI/WrappedIcon";
import Image from "next/image";
import { upperFirst } from "lodash";

type NumberedCardProps = {
  number: number;
  heading: string;
  direction?: "horizontal" | "vertical";
  text: string;
  multiline?: boolean;
  titleTag?: "span" | "h3";
  tag?: "div" | "li";
};

export const NumberedCard = ({
  number,
  heading,
  text,
  multiline,
  direction = "horizontal",
  titleTag: TitleTag = "span",
  tag: Tag = "div",
}: NumberedCardProps) => (
  <Tag className={cn(cs.cardGlassHover, s.card, s[`cardDirection${upperFirst(direction)}`])}>
    <div className={s.cardTop}>
      <div className={s.cardIconWrap}>
        <WrappedIcon shape="circle" text={number < 10 ? `0${number}` : number} className={s.cardIcon} />
        <div className={s.iconImg}>
          <Image src="/img/icon-bubble-hover.png" alt="" width={50} height={50} quality={100} />
        </div>
      </div>

      <TitleTag
        className={cn(
          {
            [cs.bodyBigSemibold]: direction === "horizontal",
            [cs.h4]: direction === "vertical",
          },
          s.title
        )}
        dangerouslySetInnerHTML={{ __html: heading }}
      />
    </div>
    {multiline ? (
      <div className={s.text} dangerouslySetInnerHTML={{ __html: text }} />
    ) : (
      <p dangerouslySetInnerHTML={{ __html: text }} />
    )}
  </Tag>
);
